import { render, staticRenderFns } from "./stockManager.vue?vue&type=template&id=7b7d5be0&scoped=true"
import script from "./stockManager.vue?vue&type=script&lang=js"
export * from "./stockManager.vue?vue&type=script&lang=js"
import style0 from "./stockManager.vue?vue&type=style&index=0&id=7b7d5be0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7d5be0",
  null
  
)

export default component.exports